import { includes, map, get, filter, isEmpty, every, some } from 'lodash'

const filteredData = ({ customerAssets, filters }) => {
  const customers = filter(customerAssets, (customerAsset) => {
    const filterResults = {}

    if (filters.customers != 'All') {
      filterResults['customers'] = includes(map(filters.customers, 'value'), get(customerAsset, 'customer_name'))
    }

    if (filters.regions != 'All') {
      filterResults['regions'] = includes(map(filters.regions, 'value'), get(customerAsset, 'region_name'))
    }

    if (filters.inCloudCore != 'All') {
      filterResults['inCloudCore'] = some(customerAsset.assets, (asset) => filters.inCloudCore === get(asset, 'inCloudCore'))
    }

    if (filters.operatingSystems != 'All') {
      filterResults['operatingSystems'] = some(
        customerAsset.assets,
        (asset) => includes(
          map(filters.operatingSystems, 'value'),
          get(asset, 'operating_system')
        )
      )
    }

    if (filters.systemTypes != 'All') {
      filterResults['systemTypes'] = some(
        customerAsset.assets,
        (asset) => includes(
          map(filters.systemTypes, 'value'),
          get(asset, 'systemType')
        )
      )
    }

    return (every(filterResults, (value, _key) => value === true) || isEmpty(filterResults))
  })

  return map(customers, customer => ({
    ...customer,
    assets: filter(customer.assets, (asset) => {
      const filterResults = {}

      if (filters.operatingSystems != 'All') {
        filterResults['operatingSystems'] = includes(
          map(filters.operatingSystems, 'value'),
          get(asset, 'operating_system')
        )
      }

      if (filters.systemTypes != 'All') {
        filterResults['systemTypes'] = includes(map(filters.systemTypes, 'value'), get(asset, 'systemType'))
      }

      if (filters.inCloudCore != 'All') {
        filterResults['inCloudCore'] = filters.inCloudCore === get(asset, 'inCloudCore')
      }

      return (every(filterResults, (value, _key) => value === true) || isEmpty(filterResults))
    })
  }))
}

export { filteredData }
